import { createContext } from 'react'
import type { StateDBService } from '../lib/db/state-db-service.ts'
import type { AppServices } from '../lib/app-services.ts'
import type { SyncEngine } from '../lib/sync/sync-engine.ts'

export interface DBContextValue {
  /** The replicated state (decks, reviews, sessions, tags). */
  service: StateDBService | null
  /** Every long-lived service; null until the local databases are open. */
  services: AppServices | null
  /** The sync engine: call `requestSync` after local writes that should reach Drive soon. */
  sync: SyncEngine | null
  /** The local databases are open. Never depends on network or Google session. */
  isReady: boolean
  error: string | null
}

export const DBContext = createContext<DBContextValue | null>(null)
